import { useEffect, useState } from 'react';
import { Col, Row } from 'reactstrap';
import KpiDashboardContainer from '../../components/KPIs/KpiDashboardContainer';
import Layout from '../../components/Layout/Layout';
import { useAuth } from '../../context/AuthContext';
import { useAvailableModulesContext } from '../../context/AvailableModulesContext';
import Routes from '../../helpers/Routes';
import { BigButton } from './BigButton';

export default function Workshop() {
    const { availableModules, canTechnicianCreateAssistances } = useAvailableModulesContext();
    const { isAdmin, isAdministrative } = useAuth();
    const { currentUser } = useAuth();
    const [isActiveKpiModule, setIsActiveKpiModule] = useState<boolean>(false);

    //modulos ativos
    useEffect(() => {
        if (availableModules.includes("IsActiveKpiModule")) {
            setIsActiveKpiModule(true);
        }
    }, [availableModules]);

    return (
        <Layout>
            <Row style={{ justifyContent: "center", alignItems: "center" }}>
                {(isAdmin() || isAdministrative() || canTechnicianCreateAssistances) && (
                    <Col xl={2} lg={2} md={12} sm={12} xs={12} style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '10%' }}>
                        <BigButton
                            path={Routes.oficina.create}
                            label={"Nova Assistência"}
                        />
                    </Col>
                )}

                <Col xl={2} lg={2} md={12} sm={12} xs={12} style={{ display: "flex", justifyContent: "center", alignItems: "center", marginTop: '10%' }}>
                    <BigButton
                        path={"/workshop/assistances"}
                        label={"Assistência Existente"}
                    />
                </Col>
            </Row>

            {isActiveKpiModule && (
                <Row style={{ margin: "2rem 1rem" }}>
                    <KpiDashboardContainer
                        technicianFilter={currentUser?.id}
                    />
                </Row>
            )}

        </Layout>
    )
}